<!-- //Molde de Paciente// -->
<div class="paciente" (click)="getInfo()">
    <img id="añadirPaciente" src="assets/media/img/añadirPaciente.svg" alt="añadir Paciente" (click)="getInfo()"> 
    <p><b>{{item.nombre |titlecase}} {{item.apellidos |titlecase}}</b></p>
    <p>{{item.horaConexion | date:'h:mm'}}</p>
</div>
